import { clientId, lpRequest } from '../../../../core/api/lp-request';
import { getMe } from './get-me';

/** A blank fee is sent as "0", as cb defaulted it; the backend refuses blanks. Answers `Me` again, as cb did. */
export const editPaymentSettings = async (
  payment_setting_id: string,
  fee_per_trip: string,
  fee_per_order: string,
  base_fee: string,
  additional_fee: string
): Promise<any> => {
  await lpRequest(`/fleet/${clientId()}/payment-settings/${payment_setting_id}`, {
    method: 'PUT',
    body: {
      fee_per_trip: String(fee_per_trip || '0'),
      fee_per_order: String(fee_per_order || '0'),
      base_fee: String(base_fee || '0'),
      additional_fee: String(additional_fee || '0')
    }
  });

  return getMe();
};
